export default class extends Error {
  constructor (resource, request, response, ...params) {
    super(...params)
    this.resource = resource
    this.request = request
    this.response = response
  }
}
